<template>
  <div class="page">
    <div class="logo" />
    <h1 class="heading">{{ heading }}</h1>
    <p class="text">{{ text }}</p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      heading: 'Page not found',
      text: 'Hi! It looks like you reached a page that no longer exists.'
    }
  }
}
</script>
<style scoped>
.page {
    position: relative;
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    padding-top: 30px;
    background: url(./../../../../assets/404.jpg) no-repeat center 240px;
    background-size: 100% auto;
}
 .logo {
  width: 260px;
  height: 50px;
  margin: 20px;
  background: url(./../../../../assets/logo.png) no-repeat;
  background-size: contain;
}
.page .heading {
    position: absolute;
    top: 180px;
    left: 30px;
    font-size: 28px;
}
.page .text {
    position: absolute;
    top: 230px;
    left: 30px;
    color: #777;
    font-size: 16px;
}
</style>
